import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'

import { Bandeira } from '../../pkw-data/collect/bandeira.model'
import { OperadoraDeMaquinaService } from '../services/operadora-de-maquina.service'

@Injectable()
export class TodasBandeirasResolver implements Resolve<Bandeira[]> {
    constructor(private operadoraService: OperadoraDeMaquinaService) {}

    resolve() {
        return this.operadoraService.obterTodasBandeiras()
    }
}



// WEBPACK FOOTER //
// ./src/app/core/resolvers/todas-bandeiras.resolver.ts